/* eslint-disable react/prop-types */
import FalconCardHeader from 'components/common/FalconCardHeader';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { Card } from 'react-bootstrap';
import { isEmpty, cloneDeep, get, round } from 'lodash';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent,
  DatasetComponent
]);

const getOption = (data, chartMetrics) => ({
  color: [getColor('primary'), getColor('gray-300')],
  dataset: { source: data },
  tooltip: {
    trigger: 'item',
    padding: [7, 10],
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    transitionDuration: 0,
    formatter: function (params) {
      return `<div className="fw-semi-bold">${
        params.seriesName
      }</div><div className="fs--1 text-600"><strong>${
        params.name
      }:</strong> ${round(params.value[params.componentIndex + 1], 2)}%</div>`;
    }
  },
  legend: {
    data: chartMetrics,
    left: 'left',
    itemWidth: 10,
    itemHeight: 10,
    borderRadius: 0,
    icon: 'circle',
    inactiveColor: getColor('gray-400'),
    textStyle: { color: getColor('gray-700') }
  },
  xAxis: {
    type: 'category',
    axisLabel: { color: '#87848A' },
    axisLine: {
      lineStyle: {
        color: getColor('gray-400'),
        type: 'dashed'
      }
    },
    axisTick: false,
    boundaryGap: true
  },
  yAxis: {
    axisPointer: { type: 'none' },
    axisTick: 'none',
    splitLine: {
      lineStyle: {
        color: getColor('gray-400'),
        type: 'dashed'
      }
    },
    axisLine: { show: false },
    axisLabel: {
      color: '#87848A',
      fontSize: 12,
      formatter: value => `${value}%`
    }
  },
  series: [
    {
      type: 'bar',
      barWidth: '10px',
      barGap: '30%',
      label: { show: false },
      z: 10,
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: getColor('primary')
      }
    },
    {
      type: 'bar',
      barWidth: '10px',
      barGap: '30%',
      label: { show: false },
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: getColor('secondary')
      }
    }
  ],
  grid: { right: '0', left: '40px', bottom: '10%', top: '20%' }
});

const SurfaceSoilMoisture = ({ environmentologyObservation }) => {
  const surfaceSoilMoisture = get(
    environmentologyObservation,
    'surface_soil_moisture',
    []
  );
  if (isEmpty(surfaceSoilMoisture)) {
    return null;
  }
  const series = cloneDeep(surfaceSoilMoisture.data[0]);
  if (!surfaceSoilMoisture.data[0].includes('product')) {
    surfaceSoilMoisture.data[0].unshift('product');
  }

  return (
    <Card>
      <FalconCardHeader
        title={environmentologyObservation?.surface_soil_moisture?.label}
        titleTag="h5"
        light
      />
      <Card.Body className="h-100">
        <p className="units-text">(in %)</p>
        <ReactEChartsCore
          echarts={echarts}
          option={getOption(surfaceSoilMoisture.data, series)}
          style={{ height: '100%', minHeight: '17.75rem' }}
        />
      </Card.Body>
      <Card.Footer className="bg-white py-2 card-footer-style">
        <h5 className="mb-0 infrence-info">
          {get(environmentologyObservation, 'surface_soil_moisture.info', '')}
        </h5>
      </Card.Footer>
    </Card>
  );
};

SurfaceSoilMoisture.propTypes = {
  data: PropTypes.array
};

export default SurfaceSoilMoisture;
